import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { HotelSearchParams } from '@models/hotel-search-params';
import { ServiceBase, apiRequest } from 'services';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class HotelService extends ServiceBase {
  searchResult: Subject<any>;
  HotelSearchSuccess: Subject<any>;
  HotelDetailsResult: Subject<any>;
  AvailableRoomsList: Subject<any>;
  hotelBookingSuccess: Subject<any>;
  hotelCancellationPolicySuccess: Subject<any>;
  PaypalSuccess: Subject<any>;
  checkRateSuccess: Subject<any>;
  PreBookRequests: Subject<any>;
  RestelPreBookRequestSuccess: Subject<any>;
  WorldCitySuccess:Subject<any>;
  WorldCityIataSuccess:Subject<any>;
  supplier$:Subject<any>;
  private httpClient:HttpClient
  constructor(http: HttpClient) {
    super(http);
    this.httpClient = http;
    this.searchResult = new Subject<any>();
    this.HotelSearchSuccess = new Subject<any>();
    this.HotelDetailsResult = new Subject<any>();
    this.AvailableRoomsList = new Subject<any>();
    this.hotelBookingSuccess = new Subject<any>();
    this.hotelCancellationPolicySuccess = new Subject<any>();
    this.PaypalSuccess = new Subject<any>();
    this.checkRateSuccess = new Subject<any>();
    this.PreBookRequests = new Subject<any>();
    this.RestelPreBookRequestSuccess = new Subject<any>();
    this.WorldCitySuccess=new Subject<any>();
    this.WorldCityIataSuccess= new Subject<any>();
    this.supplier$ = new Subject<any>();
  }

  search(params: HotelSearchParams) {
    this.post<boolean>({
      url: 'Hotels/Search/Search',
      data: params,
      onNotify: this.searchResult,
      handleErrorThroughSubject: true,
      operationKey: 'search_issue',
    } as apiRequest<boolean>);
  }

  searchBySupplier(params: any):Observable<any> {
    return this.httpClient.post('Hotels/Search/SearchBySupplier',params)
  }


  //hotel Serach dropdown
  hotelSearchDropDown(search) {
    this.post<any>({
      url: 'Hotels/hotelsearch',
      onNotify: this.HotelSearchSuccess,
      data: search,
    } as apiRequest<any>);
  }



  SearchDetailsByHotel(params) {
    this.post<boolean>({
      url: 'Hotels/Search/GetRoomsByHotel',
      data: params,
      onNotify: this.AvailableRoomsList,
      handleErrorThroughSubject: true,
      operationKey: 'SearchRooms_issue',
    } as apiRequest<any>);
  }

  getHotelDtlsById(params) {
    this.post<boolean>({
      url: 'Hotels/Search/GetHotelDtlsById',
      data: params,
      onNotify: this.HotelDetailsResult,
      handleErrorThroughSubject: true,
      operationKey: 'HotelInfo_Issue',
    } as apiRequest<any>);
  }

  HotelBookRequest(params) {
    this.post<boolean>({
      url: 'Hotels/Hotel/v1/Book',
      data: params,
      onNotify: this.hotelBookingSuccess,
      handleErrorThroughSubject: true,
      operationKey: 'Booking_issue',
    } as apiRequest<any>);
  }

  CancellationPolicyCheck(Obj) {
    this.post<boolean>({
      url: 'Hotels/Hotel/v1/CancellationPolicy',
      data: Obj,
      onNotify: this.hotelCancellationPolicySuccess,
    } as apiRequest<any>);
  }

  makePaypalPayment(paymentDetails) {
    this.post<boolean>({
      url: 'Payments/PayPal/MakePayment',
      data: paymentDetails,
      onNotify: this.PaypalSuccess,
      handleErrorThroughSubject: true,
      operationKey: 'paypal_issue',
    } as apiRequest<any>);
  }
  checkRate(rateObj) {
    this.post<boolean>({
      url: 'Hotels/Search/CheckRate',
      data: rateObj,
      onNotify: this.checkRateSuccess,
      operationKey: 'prebook_issue',
      handleErrorThroughSubject: true,
    } as apiRequest<any>);
  }

  PreBookRequest(requestObj) {
    this.post<boolean>({
      url: 'Hotels/Search/PreBookRequest',
      data: requestObj,
      onNotify: this.PreBookRequests,
      operationKey: 'prebook_issue',
      handleErrorThroughSubject: true,
    } as apiRequest<any>);
  }

  RestelPreBookRequest(requestObj) {
    this.post<boolean>({
      url: 'Hotels/Search/PreBookingRequest',
      data: requestObj,
      onNotify: this.RestelPreBookRequestSuccess,
      operationKey: 'prebook_issue',
      handleErrorThroughSubject: true,
    } as apiRequest<any>);
  }

  GetWorldCitiesById(worldCityId){
      this.get<boolean>({
        url:'Common/WorldCities/'+worldCityId,
        onNotify:this.WorldCitySuccess
      } as apiRequest<any>)
  }

  GetWorldCitiesByIata(IataCode){
    this.post<boolean>({
      url:'Common/WorldCities/Iata',
      data:IataCode,
      onNotify:this.WorldCityIataSuccess
    })
  }

  suppliers(){
    this.post<any>({
      url:'Backoffice/Supplier/v1/getSupplier',
      onNotify:this.supplier$,
      data:{Env:environment.production ? 'PROD' : "DEV",Modules:['HL']}
    });
  }
}
